import query from './services/query';
import { defaultUrl } from './services/const';
import PiwikPro from '@piwikpro/react-piwik-pro';
import { CustomEvent } from '@piwikpro/react-piwik-pro';
import { APP_CCX } from './common/CustomAppContext';

/**
 * @name redirectUrl
 * @desc URL to redirect to after login/registration.
 * @type {string}
 * @public
 */
export const redirectUrl = query.redirect || defaultUrl;

/**
 * @name followRedirectUrl
 * @desc Redirect the browser to redirect URL.
 * @public
 */
export function followRedirectUrl(url) {
    window.location.assign(url || redirectUrl);
}

export function checkPasswordRequirements(input) {
    const checks = [
        {
            message: '8 letters',
            valid: input.length >= 8,
        },
        {
            message: '1 uppercase letter',
            valid: /[A-Z]/.test(input),
        },
        {
            message: '1 special character',
            valid: /[!@#$%^&*(),.?":{}|<>]/.test(input),
        },
        {
            message: '1 number',
            valid: /\d/.test(input),
        },
        {
            message: '1 lowercase letter',
            valid: /[a-z]/.test(input),
        },
    ];

    const result = {
        isValid: checks.length === 0,
        errors: checks.map((check) => ({
            message: check.message,
            valid: check.valid,
        })),
    };

    return result;
}

export const initilizePiwikPro = () => {
    const shouldInitialize =
        process.env.REACT_APP_PIWIK_PRO_ENABLED === 'true' &&
        process.env.REACT_APP_PIWIK_PRO_ID &&
        process.env.REACT_APP_PIWIK_PRO_URL;

    if (shouldInitialize) {
        PiwikPro.initialize(
            process.env.REACT_APP_PIWIK_PRO_ID,
            process.env.REACT_APP_PIWIK_PRO_URL
        );
    }
};

export const trackCustomEvent = (
    currentApp: string,
    event: string,
    action: string,
) => {
    if (
        currentApp === APP_CCX &&
        process.env.REACT_APP_PIWIK_PRO_ENABLED === 'true'
    ) {
        CustomEvent.trackEvent(event, action);
    }
};
